import Footer from './Footer'
export type * from './types'
export { LocaleSwitchLink, FooterMobileSectionContent, FooterDesktopSectionContent } from './Footer'
export default Footer
